import $ from 'jquery';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

const showToast = (result, message) => {
    try {
        if (typeof window !== 'undefined') {
            window.$ = typeof window.$ === 'function' ? window.$ : $;
            window.jQuery = typeof window.jQuery === 'function' ? window.jQuery : $;
        }

        toastr.options = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": true,
            "positionClass": "toast-top-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "3000",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut",
            "toastClass": "toastr"
        };

        if (result) {
            toastr.success(message);
        } else {
            toastr.error(message);
        }
    } catch (error) {
        console.warn('Toast notification failed to render', error, message);
    }
};

export { showToast };
